import { render } from "./DiscussionProfileModesPage.vue?vue&type=template&id=1ad194f0&scoped=true"
import script from "./DiscussionProfileModesPage.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionProfileModesPage.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionProfileModesPage.vue?vue&type=style&index=0&id=1ad194f0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad194f0"]])

export default __exports__